/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cool_Soft_Eagle_GlideInputs */

const en_cool_soft_eagle_glide = /** @type {(inputs: Cool_Soft_Eagle_GlideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select the rounding strategy for displaying result values.`)
};

const de_cool_soft_eagle_glide = /** @type {(inputs: Cool_Soft_Eagle_GlideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie die Rundungsstrategie für die Anzeige von Ergebniswerten.`)
};

/**
* | output |
* | --- |
* | "Select the rounding strategy for displaying result values." |
*
* @param {Cool_Soft_Eagle_GlideInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cool_soft_eagle_glide = /** @type {((inputs?: Cool_Soft_Eagle_GlideInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cool_Soft_Eagle_GlideInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cool_soft_eagle_glide(inputs)
	return de_cool_soft_eagle_glide(inputs)
});